import React, { FunctionComponent } from "react";
import {
  Box,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import styles from "./styles.module.scss";
import { strings } from "../../localization/LocalizedStrings";
import { Icon, IconType } from "../../icons";

export const SwitchListItem: FunctionComponent<ISwitchListItemProps> = ({
  className,
  iconType,
  title,
  subtitle,
  labels,
  values,
  value,
  fullWidth,
  disableGutters,
  handleChange,
  helpHref,
  disabled
}) => {
  const theme = useTheme();
  return (
    <ListItem className={className} disableGutters={disableGutters}>
      <div className={styles.itemDiv}>
        {iconType && (
          <ListItemIcon>
            <Icon type={iconType} />
          </ListItemIcon>
        )}
        {title && (
          <ListItemText
            disableTypography
            className={styles.title}
            primary={title}
            secondary={
              <Typography
                className={styles.subtitle}
                style={{ color: theme.palette.primary.subtitle }}
              >
                {subtitle}
              </Typography>
            }
          />
        )}
        {helpHref && (
          <Tooltip title={strings.help} arrow disableInteractive>
            <IconButton sx={{ marginLeft: "4px" }} href={helpHref} target={"_blank"}>
              <Icon type={IconType.Help} />
            </IconButton>
          </Tooltip>
        )}
        <Box flexGrow={1} />
        <ToggleButtonGroup
          value={value}
          fullWidth={fullWidth}
          exclusive
          onChange={handleChange}
          disabled={disabled}
        >
          {labels.map((label, index) => (
            <ToggleButton
              key={`toggle_${index}`}
              className={styles.toggleButton}
              sx={{
                color: theme.palette.colors?.disabled,
                paddingTop: "4px !important",
                paddingBottom: "4px !important"
              }}
              value={values[index]}
            >
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
    </ListItem>
  );
};

export interface ISwitchListItemProps {
  className?: string;
  iconType?: IconType;
  title?: string;
  subtitle?: string;
  labels: string[];
  values: any[];
  value: any;
  fullWidth: boolean;
  disableGutters?: boolean;
  handleChange: (event: React.MouseEvent<HTMLElement>, newValue: any) => void;
  helpHref?: string;
  disabled?: boolean;
}
